<template>
  <div>
    <div class="klickbox-edit-title">{{ $t('edit.canvas.button_text') }}</div>
    <input
      v-if="!step.redirect_automatic"
      class="btn"
      type="text"
      style="padding-top:25px; margin-top:-20px;"
      @change="stepUpdateRedirectButtonText({ event: $event, id: step.id })"
      :value="step.redirect_button_text" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: [
    'step',
  ],
  methods: mapActions([
    'stepUpdateRedirectButtonText',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Redirect.vue?3c6c6a84
 **/